/**
 * @generated SignedSource<<254261150d8c4010530042981d498ac3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type WorkspaceMembersPageRevokeMutation$variables = {
  inviteId: string;
};
export type WorkspaceMembersPageRevokeMutation$data = {
  readonly revokeWorkspaceInvite: boolean;
};
export type WorkspaceMembersPageRevokeMutation = {
  response: WorkspaceMembersPageRevokeMutation$data;
  variables: WorkspaceMembersPageRevokeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "inviteId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "inviteId",
        "variableName": "inviteId"
      }
    ],
    "kind": "ScalarField",
    "name": "revokeWorkspaceInvite",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WorkspaceMembersPageRevokeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WorkspaceMembersPageRevokeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a678f3523ae3670f83aa884b081562d5",
    "id": null,
    "metadata": {},
    "name": "WorkspaceMembersPageRevokeMutation",
    "operationKind": "mutation",
    "text": "mutation WorkspaceMembersPageRevokeMutation(\n  $inviteId: ID!\n) {\n  revokeWorkspaceInvite(inviteId: $inviteId)\n}\n"
  }
};
})();

(node as any).hash = "966f86727a4b1b642e266636a4d09d3d";

export default node;
